export default {
    setStaff(state, payload) {
        state.baskets = payload;
    },
};